// Small client-side CSV exporter — RFC 4180 quoting for safety with commas, quotes, newlines.

function escapeCell(v: unknown): string {
  if (v === null || v === undefined) return '';
  const s = Array.isArray(v) ? v.join('; ') : typeof v === 'object' ? JSON.stringify(v) : String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export interface CsvColumn<Row> {
  header: string;
  accessor: (row: Row) => unknown;
}

export function downloadCsv<Row>(filename: string, columns: CsvColumn<Row>[], rows: Row[]): void {
  const headerLine = columns.map((c) => escapeCell(c.header)).join(',');
  const dataLines = rows.map((row) => columns.map((c) => escapeCell(c.accessor(row))).join(','));
  const body = [headerLine, ...dataLines].join('\n');
  // Prepend a UTF-8 BOM so Excel opens it correctly.
  const blob = new Blob(['﻿', body], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
